const PREFIX = '[Modal Error]';

export const MODAL_ERROR_SHOW = `${PREFIX} MODAL_ERROR_SHOW`;
export const MODAL_ERROR_HIDE = `${PREFIX} MODAL_ERROR_HIDE`;

export const modalErrorShow = (error, preventPageReload) => ({
  type: MODAL_ERROR_SHOW,
  error,
  preventPageReload,
});

export const modalErrorHide = () => ({
  type: MODAL_ERROR_HIDE,
});
